import React from 'react';

const TopBanner = () => {
  return (
    <div className="w-full bg-[#707070] text-white py-3.5 px-4 text-center font-bold tracking-wide">
      <span className="text-base md:text-lg font-extrabold uppercase">
        Not for Resale or Human Consumption &mdash; Research Purposes Only
      </span>
    </div>
  );
};

export default TopBanner;
